import React, { useContext, useState, useEffect } from 'react'
import {
    Row,
    Col,
    Card,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Form,
    Button
} from 'reactstrap'
import ApiService from '../../../data/services/ApiService'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { GeneralContext } from '../../../context/'
import { Link } from 'react-router-dom'

const Users = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext
    const [users, setUsers] = useState([])
    const [user, setUser] = useState({
        firstName: '',
        lastName: '',
        countryCode: '',
        phone: '',
        email: '',
        password: '',
        roleId: '',
    })

    useEffect(() => {
        (async () => {
            await fetchUsers()
        })()
    }, []) // eslint-disable-line

    const fetchUsers = async () => {
        try {
            const response = await ApiService.getUsers()

            setUsers(response.data.users)
        } catch (error) {
            toastr.error(`No pude comunicarme con el servidor`, 'Problema de Conexión')
        } finally {
            setLoading(false)
        }
    }

    const _handleSubmit = async (e) => {
        try {
            e.preventDefault()
            setLoading(true)

            const response = await ApiService.createUser(user)
            if (!response) {
                toastr.error(`No pude actualizar los datos`)

                return
            }

            toastr.success(`Usuario agregado`)
            props.closeModal(false)
        } catch (error) {
            toastr.error(`No pude actualizar los datos`)
        } finally {
            setLoading(false)
        }
    }

    const _deleteUser = async (id) => {
        try {
            setLoading(true)
            await ApiService.deleteUser(id)
            const nusers = await users.filter((v) => { return v.id !== id })

            setUsers(nusers)

            toastr.success(`Eliminaste un usuario`)
            window.analytics.track('Branch deleted')
        } catch (error) {
            toastr.error(`No pude eliminar al usuario`)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Row>
            <Col sm={12} lg={6}>
                <Card>
                    <CardTitle>Agregar Usuario</CardTitle>
                    <CardBody>
                        <Form id="users-create" method="POST" onSubmit={_handleSubmit}>
                            <FormGroup>
                                <Label htmlFor="firstName">
                                    Nombre/s
                                </Label>

                                <Input
                                    id="firstName"
                                    name="firstName"
                                    type="text"
                                    className="form-control"
                                    value={user.firstName}
                                    onChange={event => setUser({
                                        ...user,
                                        firstName: event.target.value
                                    })}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label htmlFor="lastName">
                                    Apellido/s
                                </Label>

                                <Input
                                    id="lastName"
                                    name="lastName"
                                    type="text"
                                    className="form-control"
                                    value={user.lastName}
                                    onChange={event => setUser({
                                        ...user,
                                        lastName: event.target.value
                                    })}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label htmlFor="email">
                                    Email
                                </Label>

                                <Input
                                    id="email"
                                    name="email"
                                    type="email"
                                    className="form-control"
                                    value={user.email}
                                    onChange={event => setUser({
                                        ...user,
                                        email: event.target.value
                                    })}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label htmlFor="phone">
                                    Teléfono
                                </Label>

                                <Input
                                    id="phone"
                                    name="phone"
                                    type="tel"
                                    className="form-control"
                                    value={user.phone}
                                    onChange={event => setUser({
                                        ...user,
                                        phone: event.target.value
                                    })}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label htmlFor="password">
                                    Password
                                </Label>

                                <Input
                                    id="password"
                                    name="password"
                                    type="password"
                                    className="form-control"
                                    value={user.password}
                                    onChange={event => setUser({
                                        ...user,
                                        password: event.target.value
                                    })}
                                />
                            </FormGroup>

                            <Button
                                color='primary'>
                                Agregar usuario
                            </Button>
                        </Form>
                    </CardBody>
                </Card>
            </Col>
            <Col sm={12} lg={6}>
                <Card>
                    <CardTitle>Lista de Usuarios</CardTitle>
                    <CardBody>

                        {users.map((item, key) => (
                            <Col md={6} key={key}>
                                <Card>
                                    <CardTitle>{item.firstName} {item.lastName}</CardTitle>
                                    <CardBody>
                                        <strong>E-Mail:</strong> {item.email}<br />
                                        <strong>Teléfono:</strong> {item.phone}<br />
                                    </CardBody>
                                    <CardFooter className="bg-transparent border-top">
                                        <div className="d-flex font-size-20">
                                            <div className="flex-fill">
                                                <Link id={'edit'} to={`/users/edit/${item.id}`}>
                                                    <i className="mdi mdi-pencil"></i> Editar
                                                </Link>
                                            </div>

                                            <div className="flex-fill">
                                                <Link id={'delete'} to={`#`} onClick={(e) => {
                                                    e.preventDefault()
                                                    _deleteUser(item.id)
                                                }}>
                                                    <i className="mdi mdi-trash-can font-size-16 mr-2"></i> Eliminar
                                                </Link>
                                            </div>
                                        </div>
                                    </CardFooter>
                                </Card>
                            </Col>
                        ))}
                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}

export default Users